import React, { useContext } from 'react';

import { RicosNodeContext, RicosNodeContextProvider } from './../../ricos-context';
import type { NodeViewRendererProps } from './../../ricos-types';

const TableRow = ({ node, nodeIndex, RicosNodesRenderer }: NodeViewRendererProps) => {
  const { parentNode } = useContext(RicosNodeContext);
  const style = { height: parentNode?.tableData?.dimensions?.rowsHeight?.[nodeIndex] || 'auto' };

  return (
    <tr style={style}>
      <RicosNodeContextProvider parentNode={parentNode} parentIndex={nodeIndex}>
        <RicosNodesRenderer nodes={node.nodes ?? []} />
      </RicosNodeContextProvider>
    </tr>
  );
};

const TableRowRenderer = ({ node, ...props }: NodeViewRendererProps) => {
  return <TableRow key={node.id} node={node} {...props} />;
};

export default TableRowRenderer;
